export const unitlessPxtoPx = (...args: number[]) => {
  return `${args.map((arg) => `${arg}px`).join(" ")}`;
};

export const unitlessPxtoRem = (...args: number[]) => {
  return `${args.map((arg) => `${arg / 16}rem`).join(" ")}`;
};

export const safeToRem = (value: number | undefined | string) => {
  if (value === undefined) {
    return undefined;
  }

  if (typeof value === "string") {
    return value;
  }

  return unitlessPxtoRem(value);
};

export const isPx = (arg: string): arg is `${number}px` => arg.endsWith("px");

export const isRem = (arg: string): arg is `${number}rem` =>
  arg.endsWith("rem");

export const pxOrRemToUnitlessPx = (arg: `${number}px` | `${number}rem`) => {
  if (isRem(arg)) {
    return parseFloat(arg.replace("rem", "")) * 16;
  }
  return parseFloat(arg.replace("px", ""));
};
